export const SAP_EMPLOYEE_WARNING_SHOWN_KEY = 'sap_employee_warning_shown';
